module.exports = __webpack_public_path__ + "media/images/shared/ad/muevo_COVID19_bannner_02-073f6269886fdfd17bfd192f56b3dc34.jpg";